import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '@core/types';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { RouterLink } from '@angular/router';
import { FeatherIconDirective } from '../../../../directives/core-feather-icons/core-feather-icons';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
    selector: '[core-menu-vertical-item]',
    templateUrl: './item.html',
    imports: [NgClass, DefaultClassDirective, RouterLink, NgTemplateOutlet, FeatherIconDirective, TranslateDirective]
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;
}
